import {
  Button,
  Empty,
  Form,
  Input,
  Pagination,
  Radio,
  Row,
  Space,
  Spin
} from 'antd';
import { ClassroomCard } from './components/ClassroomCards';
import { CrudFilters, HttpError } from '@refinedev/core';
import { IProfessorClassroom } from 'interfaces/professor_area/classrooms';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { SearchOutlined } from '@ant-design/icons';
import { useTable } from '@refinedev/antd';

interface IFilter {
  status: 'active' | 'not_started' | 'finished';
  search?: string;
}

export const ClassroomList = () => {
  const { searchFormProps, tableQueryResult, pageSize, current, setCurrent } =
    useTable<IProfessorClassroom, HttpError, IFilter>({
      pagination: {
        mode: 'server',
        pageSize: 12
      },
      filters: {
        initial: [{ field: 'filter[active]', operator: 'eq', value: true }],
        defaultBehavior: 'replace'
      },
      onSearch: ({ status, search }) => {
        const filters: CrudFilters = [
          {
            field: `filter[${status ?? 'active'}]`,
            operator: 'eq',
            value: true
          }
        ];

        if (search?.trim()) {
          filters.push({
            field: 'filter[search]',
            operator: 'eq',
            value: search.trim()
          });
        }

        return filters;
      }
    });

  const classroomsList =
    tableQueryResult?.data?.data ?? ([] as IProfessorClassroom[]);

  return (
    <ListLayout title="Turmas" canCreate={false}>
      <Space direction="vertical" className="w-full">
        <Form
          {...searchFormProps}
          initialValues={{ status: 'active', ...searchFormProps.initialValues }}
        >
          <Row className="gap-4 items-center my-4">
            <Form.Item name="search" className="!mb-0 flex-1 min-w-[240px]">
              <Input
                allowClear
                placeholder="Buscar por nome da disciplina ou código da turma"
                suffix={<SearchOutlined />}
                onClear={() => searchFormProps.form?.submit()}
                onPressEnter={() => searchFormProps.form?.submit()}
              />
            </Form.Item>

            <Button type="default" htmlType="submit" icon={<SearchOutlined />}>
              Buscar
            </Button>

            <Form.Item name="status" className="!mb-0">
              <Radio.Group
                buttonStyle="solid"
                onChange={() => searchFormProps.form?.submit()}
              >
                <Radio.Button value="active">Em andamento</Radio.Button>
                <Radio.Button value="not_started">Não iniciadas</Radio.Button>
                <Radio.Button value="finished">Finalizadas</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Row>
        </Form>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {classroomsList?.map(classroom => (
            <ClassroomCard key={classroom.id} classroom={classroom} />
          ))}
        </div>

        {tableQueryResult.isLoading && (
          <Row className="w-full flex justify-center">
            <Spin className="self-center" />
          </Row>
        )}

        {!tableQueryResult.isLoading &&
          classroomsList &&
          classroomsList?.length < 1 && (
            <Row className="w-full flex justify-center">
              <Empty description="Nenhuma turma encontrada para os filtros selecionados." />
            </Row>
          )}

        <Pagination
          className="justify-self-end"
          hideOnSinglePage
          total={tableQueryResult.data?.total}
          onChange={setCurrent}
          current={current}
          pageSize={pageSize}
        />
      </Space>
    </ListLayout>
  );
};
